export enum ChartColumnEnum {
    Completeness = 1,
    Connections,
    Deviation,
    Duration,
    EndDateFact,
    EndDatePlan,
    HasConnection,
    Responsible,
    StartDateFact,
    StartDatePlan,
    Weight,
}
